import * as PIXI from 'pixi.js'
import PropTypes from 'prop-types'

import app from 'common/builder/components/chart/FlowChart/app'
import PixiObject from 'common/builder/components/chart/FlowChart/pixi-object'

const highlightedColor = 0x0084ff
const selectedColor = 0x0bcb6b

export default class SelectionFrames extends PixiObject {
  static propTypes = {
    selected: PropTypes.object,
  }

  handleSelectionFrame = (frame) => {
    this.selectionFrame = frame
  }

  setBorderWidth = () => {
    this.borderWidth = app.getNodeFrameWidth()
  }

  drawFrame = (node, selected = false) => {
    if (typeof node.getChildren !== 'function') {
      return
    }
    const nodeCard = node.getChildren()[0]
    if (nodeCard && nodeCard.layout) {
      const { x, y } = node.getAbsolutePosition()
      const { width, height } = nodeCard.layout
      // TODO: get radius from node config
      const radius = nodeCard.sharedResourceId === 'comment-node' ? 16 : 30
      if (!selected && nodeCard.highlightColor != null) {
        this.setFrameColor(nodeCard.highlightColor)
        this.g.drawRoundedRect(x, y, width, height, radius)
        this.setFrameColor(highlightedColor)
      } else {
        this.g.drawRoundedRect(x, y, width, height, radius)
      }
    }
  }

  setFrameColor = (color) => {
    this.g.lineStyle(this.borderWidth, color, 1, 0)
  }

  prepareGraphics = () => {
    const { obj } = this
    const { parent } = obj
    const desiredIndex = parent.children.length - 1
    if (parent.getChildIndex(obj) !== desiredIndex) {
      parent.setChildIndex(obj, desiredIndex)
    }
    this.g.clear()

    this.setBorderWidth()
  }

  renderFrames = () => {
    this.prepareGraphics()
    const nodes = app.getNodes()
    const { selected } = this.props
    const selectedNodes = nodes.filter((n) => selected[n.id])
    const hoveredNodes = [app.getHoveredNode()].filter((n) => !!n && !app.isChooseFirstStepNode(n))
    const highlighted = app.getHighlightedIds()
    const highlightedNodes = nodes.filter((n) => highlighted.includes(n.id))

    if (this.selectionFrame) {
      const selectionFrameNodes = nodes.filter(
        (n) => n.ctx && n.ctx.intersectsRect(this.selectionFrame),
      )
      hoveredNodes.push(...selectionFrameNodes)
    }

    this.setFrameColor(highlightedColor)
    for (let node of hoveredNodes) {
      if (selectedNodes.includes(node)) {
        continue
      }
      this.drawFrame(node)
    }

    for (let node of highlightedNodes) {
      this.drawFrame(node)
    }

    this.setFrameColor(selectedColor)
    for (let node of selectedNodes) {
      if (highlightedNodes.includes(node)) {
        continue
      }
      this.drawFrame(node, true)
    }
  }

  createObject() {
    const container = new PIXI.Container()
    this.g = new PIXI.Graphics()
    this.g.testId = 'selection-frame'
    this.layer = new PIXI.Container()
    this.layer.id = 'foreground'
    container.addChild(this.g)
    container.addChild(this.layer)
    app.setNode(this.layer)

    app.on('willRender', this.renderFrames)
    app.on('selectionframe', this.handleSelectionFrame)

    this.borderWidth = app.getNodeFrameWidth()

    return container
  }

  rerender() {
    this.renderFrames()
  }

  onUnmount() {
    app.deleteNode(this.layer)
    app.removeListener('willRender', this.renderFrames)
    app.removeListener('selectionframe', this.handleSelectionFrame)
  }
}
